module.exports = __webpack_public_path__ + "static/img/8.3628650.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/5/eng/8.png
// module id = 00MN
// module chunks = 0